import { RootState } from "../../../store/types";
import { connect } from "react-redux";
import ShiftDataTable from "./ShiftDataTable";

const mapStateToProps = (state: RootState) => ({
    shiftSummary: state.reviewAndPublish.shiftPlanOutput?.shiftSummary
});

export default connect(mapStateToProps)(ShiftDataTable);
